import { z } from "zod";
import { FrontComponentNameSchema, FrontPositionSchema } from "./event";

export const ToolCallSchema = z.object({
  tool_id: z.string(),
  name: z.string(),
  arguments: z.string(),
  tool_result_status: z.enum(["tool_success", "tool_error", "tool_crash"]),
  error: z.string().nullable().optional(),
  front_component_name: FrontComponentNameSchema.nullable().optional(),
  front_position: FrontPositionSchema.nullable().optional(),
  front_component_data: z.record(z.string(), z.any()).nullable().default(null),
});

export const ToolCallsSchema = z.record(z.string(), ToolCallSchema);

// Base Message Schema (common fields)
const BaseMessageSchema = z.object({
  id: z.number(),
  created_at: z.string(),
  parent_id: z.number().nullable().optional(),
  content: z.string(),
});

// User/Assistant Message Schema
export const UserMessageSchema = BaseMessageSchema.extend({
  role: z.enum(["user"]),
});

// Tool Message Schema

export const ToolMessageSchema = BaseMessageSchema.extend({
  role: z.enum(["tool"]),
  tool_calls: ToolCallsSchema.nullable().optional(),
});

// Assistant Message Schema
export const AssistantMessageSchema = BaseMessageSchema.extend({
  role: z.enum(["assistant"]),
  tool_calls: ToolCallsSchema.nullable().optional(),
});

// Combined Message Schema using discriminated union
export const AIMessageSchema = z.discriminatedUnion("role", [
  UserMessageSchema,
  ToolMessageSchema,
  AssistantMessageSchema,
]);

// Conversation Schema with messages as a dictionary (Record<number, AIMessage>)
export const AIConversationSchema = z.object({
  id: z.number(),
  title: z.string().nullable(),
  created_at: z.string().nullable(),
  messages: z.record(z.number(), AIMessageSchema).optional(),
});

// Type inference from Zod
export type UserMessage = z.infer<typeof UserMessageSchema>;
export type AssistantMessage = z.infer<typeof AssistantMessageSchema>;
export type ToolMessage = z.infer<typeof ToolMessageSchema>;
export type AIMessage = z.infer<typeof AIMessageSchema>;
export type AIConversation = z.infer<typeof AIConversationSchema>;

export const OneConversationSchema = z.array(AIMessageSchema).readonly();

export const ConversationsListSchema = z.array(AIConversationSchema);

export type ToolCallData = z.infer<typeof ToolCallSchema>;
